import React, { Component } from "react";

import { Basemap } from "@formant/core/model/ILocationViewConfiguration";

import { Select } from "../../common/Select";

export interface IBasemapSelectorProps {
    basemap: Basemap;
    onChange: (mode: Basemap) => void;
}

const basemaps: Basemap[] = ["streets", "satellite"];

export class BasemapSelector extends Component<IBasemapSelectorProps> {
    public render() {
        const { basemap, onChange } = this.props;

        return (
            <Select
                value={basemap}
                options={basemaps}
                simple={true}
                onChange={onChange}
            />
        );
    }
}
